var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('i',{staticClass:"iconfont",on:{"click":function($event){return _vm.back()}}},[_vm._v("")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(!_vm.atGame)?_c('i',{staticClass:"iconfont"},[_vm._v("")]):_c('i',{staticClass:"iconfont",on:{"click":_vm.searchInput}},[_vm._v("")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec6db40","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader/AppHeader.vue
// module id = null
// module chunks = 